<template>
    <div class="container-fluid">
      
        <div class="row">
            <div class="col-xl-8 col-lg-8 col-sm-7 col-xs-12">
                <div id="panel-description" class="panel">
                    <div class="panel-hdr bg-primary-700 bg-success-gradient">
                        <h2>{{this.protocol?.protocol_title}}</h2>
                        
                        <div class="panel-toolbar">
                            <button class="btn btn-panel waves-effect waves-themed" data-action="panel-collapse"
                                    data-toggle="tooltip" data-offset="0,10" data-original-title="Collapse">
                            </button>
                            
                            <button class="btn btn-panel waves-effect waves-themed" data-action="panel-fullscreen"
                                    data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen">
                            </button>
                        </div>
                    </div>
                    <BOverlay key="tab" :show="is_load">
                        <div class="panel-container collapse show overflow-auto">
                            <div class="pl-2 pt-2 pb-2">
                                <protocol_inside_payment :protocol="protocol"></protocol_inside_payment>
                            </div>
                            <div class="panel-content" v-if="is_loaded">
                                <protocol_inside_positions :protocol="protocol"></protocol_inside_positions>
                                <protocol_inside_winners_down :protocol="protocol"></protocol_inside_winners_down>
                                
                                <div class="description mt-2">
                                    <legend>Опис</legend>
                                    <div class="description_inseid" v-html="protocol?.description"></div>
                                </div>
                                
                                <div class="changes" v-if="protocol.changes.length > 0">
                                    <protocol_changes :protocol="protocol"></protocol_changes>
                                </div>
                            </div>
                        </div>
                    </BOverlay>
                </div>
            </div>
            
            <div class="col-xl-4 col-lg-4 col-sm-5 col-xs-12">
                <protocol_inside_memorandum :protocol="protocol"></protocol_inside_memorandum>
                <protocol_inside_winners :protocol="protocol"></protocol_inside_winners>
            </div>
        
            <protocol_new_tour :protocol="protocol"></protocol_new_tour>
        
        </div>
        <rating_contragent></rating_contragent>
       
    </div>
</template>

<script>

import {
    BTabs,
    BTab,
    BOverlay,
    BSpinner,
    BButton,
    BButtonGroup
} from 'bootstrap-vue-next';
import Protocol_inside_payment from "./block/protocol_inside_payment.vue";
import Protocol_inside_positions from "./block/protocol_inside_positions.vue";
import Protocol_inside_memorandum from "./block/protocol_inside_memorandum.vue";
import Protocol_inside_winners from "./block/protocol_inside_winners.vue";
import Protocol_inside_winners_down from "./block/protocol_inside_winners_down.vue";
import Rating_contragent from "../../rating/rating_contragent.vue";
import Protocol_new_tour from "./new_tour/protocol_new_tour.vue";
import Protocol_changes from "./changes/protocol_changes.vue";
export default {
    name: "protocol_inside",
    
    components : {
        Protocol_changes,
        Protocol_new_tour,
        Rating_contragent,
        Protocol_inside_winners_down,
        Protocol_inside_winners,
        Protocol_inside_memorandum,
        Protocol_inside_positions,
        Protocol_inside_payment,
        BTabs,
        BTab,
        BOverlay,
        BSpinner,
        BButton,
        BButtonGroup
    },
    props: {
        protocol_id: {
            type: [Number, String],
            default : 0,
        },
        
        tender_id : {
            type: [Number, String],
            default : 0,
        }
    },
    
    data() {
        return {
            is_load: false,
            is_loaded : false,
            tabId : "protocol_general",
            protocol : {
                id : 0,
                rate_from_protocol : 0,
                position_grid_add : [],
                calculated_sum : {
                    cur_sum : 0,
                    opt_sum : 0,
                }
            },
            tabs : []
        }
    },
    created() {
        EventBus.$on('application:updated',this.loadProtocol);
        this.protocol.id = this.protocol_id;
        this.loadProtocol();
    },
    
    methods : {
        async loadProtocol(currency_type = -1) {
            this.is_load = true;
            this.is_loaded = false;
            let self = this;
            let body = {
                'tender_id'     : this.tender_id,
                'protocol_id'   : this.protocol.id,
            }
            
            if(parseInt(currency_type) >= 0) {
                body['rate_from_protocol'] = currency_type;
            }
            
            await axios.post('/internal/protocol/getProtocol',body).then(({data}) => {
                this.is_load = false;
                this.is_loaded = true;
                if(data.status === "operation_success") {
                    self.protocol = data.data;
                }
            }).catch(({response}) => {
                console.log(response);
                EventBus.$emit('show_toast', {
                    err: response.data.message, type: "danger",
                    title: response.data.status,
                    position : "b-toaster-top-left"
                })
            });
        },
    }
    
}
</script>


<style scoped>

</style>